module.exports = __webpack_public_path__ + "static/media/PANELtop.5ce1dd51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layers/PANELtop.png
// module id = 164
// module chunks = 0